import {
  Alert,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
} from "@heroui/react";
import { Code2, List, Megaphone, Server } from "lucide-react";

import { useDialog } from "@/contexts/DialogContext";

import { Button } from "../core/Button";

const EVENT_ANNOUNCEMENTS_URL =
  "https://lists.sc07.com/postorius/lists/events-announcements.lists.sc07.com/";
const INSTANCE_ADMINS_URL =
  "https://lists.sc07.com/postorius/lists/events-instances.lists.sc07.com/";
const CANVAS_DEVELOPMENT_URL =
  "https://lists.sc07.com/postorius/lists/canvas.sc07.dev/";
const MAILING_LISTS_URL = "https://lists.sc07.com/";

export const MailingListsModal = () => {
  const Dialog = useDialog();
  const { isOpen, onClose } = useDisclosure({
    isOpen: "MAILING_LISTS" in Dialog.state.dialogs,
    onClose: () =>
      Dialog.dispatch({ action: "CLOSE_DIALOG", dialogId: "MAILING_LISTS" }),
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} placement="center">
      <ModalContent className="canvas-overlay-card">
        {(onClose) => (
          <>
            <ModalHeader>Mailing Lists</ModalHeader>
            <ModalBody>
              <p>
                Get email announcements about upcoming Fediverse events or
                other topics.
              </p>
              <div className="flex flex-wrap gap-2">
                <Button
                  as={Link}
                  color="primary"
                  href={EVENT_ANNOUNCEMENTS_URL}
                  startContent={<Megaphone aria-hidden="true" size={16} />}
                  target="_blank"
                  variant="flat"
                >
                  Event Announcements
                </Button>
                <Button
                  as={Link}
                  color="primary"
                  href={INSTANCE_ADMINS_URL}
                  startContent={<Server aria-hidden="true" size={16} />}
                  target="_blank"
                  variant="flat"
                >
                  Instance Admins
                </Button>
                <Button
                  as={Link}
                  color="primary"
                  href={CANVAS_DEVELOPMENT_URL}
                  startContent={<Code2 aria-hidden="true" size={16} />}
                  target="_blank"
                  variant="flat"
                >
                  Canvas Development
                </Button>
              </div>

              <Alert
                classNames={{ title: "font-semibold" }}
                color="primary"
                description={
                  <>
                    View all available mailing lists and manage your
                    subscriptions to them.
                    <br />
                    <Button
                      as={Link}
                      href={MAILING_LISTS_URL}
                      size="sm"
                      startContent={<List aria-hidden="true" size={16} />}
                      target="_blank"
                      variant="flat"
                    >
                      View Lists
                    </Button>
                  </>
                }
                title="All Lists"
                variant="faded"
              />
            </ModalBody>
            <ModalFooter>
              <Button onPress={onClose}>Close</Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
